module.exports = __webpack_public_path__ + "static/media/hamta_logo.323cd138.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/hamta_logo.svg
// module id = 172
// module chunks = 0